import * as React from 'react';

export const FaceLaughRelaxedIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="face-laugh-relaxed">
      <path
        id="Vector"
        opacity="0.4"
        d="M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22Z"
        fill="#FF7A00"
      />
      <path
        id="Vector_2"
        d="M15.46 14C15.77 14 16 14.28 15.96 14.59C15.68 16.52 14.02 18 12 18C9.98 18 8.33001 16.52 8.04001 14.59C8.00001 14.28 8.23001 14 8.54001 14H15.46ZM17.11 10.21C17.5 10.07 17.71 9.64999 17.57 9.25999C17.26 8.35999 16.41 7.75 15.45 7.75C14.49 7.75 13.64 8.34999 13.33 9.25999C13.2 9.64999 13.4 10.08 13.79 10.21C14.19 10.35 14.61 10.14 14.74 9.75C14.84 9.46 15.13 9.25999 15.44 9.25999C15.75 9.25999 16.04 9.46 16.14 9.75C16.25 10.06 16.54 10.26 16.85 10.26C16.93 10.26 17.01 10.25 17.1 10.22L17.11 10.21ZM10.29 10.21C10.68 10.07 10.89 9.64999 10.75 9.25999C10.44 8.35999 9.59001 7.75 8.63001 7.75C7.67001 7.75 6.82001 8.34999 6.51001 9.25999C6.38001 9.64999 6.58 10.08 6.97 10.21C7.37 10.35 7.79002 10.14 7.92002 9.75C8.02002 9.46 8.31 9.25999 8.62 9.25999C8.93 9.25999 9.22001 9.46 9.32001 9.75C9.43001 10.06 9.72 10.26 10.03 10.26C10.11 10.26 10.19 10.25 10.28 10.22L10.29 10.21Z"
        fill="#FF7A00"
      />
    </g>
  </svg>
);
